import { createContext, useState, useContext } from "react";
const TransactionContext = createContext();

export const TransactionProvider = ({ children }) => {
  const [transactions, setTransactions] = useState([]);
  const [unbilledTransactions, setUnbilledTransactions] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(0);
  const [numberOfDates, setNumberOfDates] = useState(0);
  const [billingCycleDates, setBillingCycleDates] = useState({
    from: "", // YYYY-MM-DD
    to: "" // YYYY-MM-DD
  });
  const [isLogin, setIsLogin] = useState(false);
  const [userDetails, setUserDetails] = useState({
    phoneNumber: 0,
    cardSerNo: 0,
    deviceId: 0,
    dob: "",
    otp: "",
    sessionKey: "",
    superMoneyAccountId: "",
    last4Digits: 0,
    name: "",
    email: "",
    cardAccountNumber: "",
    codeVerifier: ""
  });
  const [paymentStatus, setPaymentStatus] = useState(false);

  const updateUserDetail = (key, value) => {
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [key]: value
    }));
  };

  const addTransaction = (newTransaction) => {
    setTransactions(newTransaction);
    // console.log("storing: ", newTransaction);
  };

  const updateBillingCycle = (billingDates) => {
    setBillingCycleDates({
      from: billingDates.from,
      to: billingDates.to
    });

    sessionStorage.setItem("billingDates", JSON.stringify(billingDates));
  };

  const addUnbilledTransaction = (newTransaction) => {
    setUnbilledTransactions(newTransaction);
  };

  return (
    <TransactionContext.Provider
      value={{
        transactions,
        addTransaction,
        unbilledTransactions,
        addUnbilledTransaction,
        setCurrentMonth,
        currentMonth,
        setTransactions,
        setUnbilledTransactions,
        numberOfDates,
        setNumberOfDates,
        setIsLogin,
        isLogin,
        userDetails,
        setUserDetails,
        updateUserDetail,
        setPaymentStatus,
        paymentStatus,
        billingCycleDates,
        updateBillingCycle
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransaction = () => useContext(TransactionContext);
